import { Breadcrumb, Row, Col, Card, Dropdown } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import PageTitle from "../../PageTitle";
import { BsThreeDotsVertical } from "react-icons/bs";
import WebService from "../../../Services/WebService";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import moment from "moment";
import DeleteModal from "../../Common/DeleteModal/DeleteModal";
import PageLoader from "../../Common/Loader/PageLoader";
import HelperService from "../../../Services/HelperService";

const ReceiptDetail = () => {
  let param = useParams();
  const [receiptInfo, setReceiptInfo] = useState({
    receipt_uuid: "",
    receiptNo: "",
    date: "",
    received_From: "",
    property_name: "",
    building_name: "",
    unit: "",
    bed: "",
    room: "",
    received_to: "",
    receipt_details: [],
    property_type: "",
    payment_mode: "",
    total_amount: 0,
  });
  const [action, setAction] = useState("");
  const handleCloseModal = (flag: any) => {
    if (flag) {
      history.back();
    }
    setShow(false);
  };
  const [show, setShow] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);

  let navigate = useNavigate();
  useEffect(() => {
    if (param.receipt_uuid !== undefined) {
      getReceiptInfo(param.receipt_uuid);
    }
  }, []);
  const getReceiptInfo = (receipt_id: any) => {
    setPageLoader(true);
    return WebService.getAPI({
      action: `receipt/${receipt_id}/info`,
      isShowError: true,
    })
      .then((res: any) => {
        setReceiptInfo((prev: any) => ({
          ...prev,
          receipt_uuid: res?.info?.uuid,
          receiptNo: res?.info?.receipt_no,
          date: moment(res?.info?.date).format("DD-MMM-YYYY"),
          received_From: res?.info?.tenant?.name ?? "",
          property_name: res?.info?.tenant?.booked_detail?.property?.name ?? "",

          building_name:
            res?.info?.tenant?.booked_detail?.building?.building_name ?? "",
          unit: res?.info?.tenant?.booked_detail?.floor_unit?.room_no ?? "",
          room:
            res?.info?.tenant?.booked_detail?.room?.master_value?.title ?? "",
          bed: res?.info?.tenant?.booked_detail?.bed?.value,

          received_to: res?.info?.organization?.name ?? "",
          property_type:
            res?.info?.tenant?.booked_detail?.property?.property_type ?? "",
          receipt_details: res?.info?.receipt_details,
          payment_mode: res?.info?.payment_method,
          total_amount:
            res?.info?.receipt_details?.length > 0
              ? res?.info?.receipt_details?.reduce(
                  (total: any, item: any) => total + item.amount,
                  0
                )
              : 0,
        }));
        setPageLoader(false);
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        setPageLoader(false);
        return error;
      });
  };
  const handleEdit = () => {
    navigate(`/accounting/edit-receipt/${receiptInfo?.receipt_uuid}`);
  };
  return (
    <>
      {pageLoader ? (
        <PageLoader />
      ) : (
        <div className="app-page page-properties pb-3">
          <div className="nb-3">
            <Breadcrumb>
              <Breadcrumb.Item href="#">Accounting</Breadcrumb.Item>
              <Breadcrumb.Item href="#">Receipts</Breadcrumb.Item>
              <Breadcrumb.Item active>
                {receiptInfo?.receiptNo ?? "-"}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Row className=" mb-lg-4 mb-3">
            <Col lg={8} xs={8}>
              <div className="d-flex gap-3 align-items-center">
                <PageTitle
                  title={receiptInfo?.receiptNo ?? "-"}
                  backArrow={true}
                />
              </div>
            </Col>
            <Col lg={4} xs={4} className="d-flex justify-content-end gap-3">
              <Dropdown
                align="end"
                autoClose="outside"
                className="action-dropdown action-dd-mob"
              >
                <Dropdown.Toggle
                  className="btn btn-outline-light"
                  id="dropdown-basic"
                >
                  <span className="d-none d-lg-block">Action</span>
                  <BsThreeDotsVertical
                    size={16}
                    className="text-secondary d-lg-none d-block"
                  />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Link
                    to="javascript:void(0)"
                    onClick={() => handleEdit()}
                    className="dropdown-item"
                  >
                    Edit
                  </Link>
                  <Link to="javascript:void(0)" onClick={() => window.print()} className="dropdown-item">
                    Print
                  </Link>
                  <Link
                    to="javascript:void(0)"
                    onClick={() => {
                      setAction(`receipt/${receiptInfo?.receipt_uuid}/delete`);
                      setShow(true);
                    }}
                    className="dropdown-item"
                  >
                    Delete
                  </Link>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          </Row>

          <Card className="card-style mb-lg-4 mb-3">
            <Card.Header>
              <h4 className="card-title">Receipts Details</h4>
            </Card.Header>
            <Card.Body>
              <Row className="w-100">
                <Col lg={3} xs={6} className="mb-3 ">
                  <label className="text-secondary-dark mb-1">
                    Receipt No.
                  </label>
                  <p className="mb-0 font-14 font-semibold">
                    {receiptInfo?.receiptNo ?? "-"}
                  </p>
                </Col>
                <Col lg={3} xs={6} className="mb-3">
                  <label className="text-secondary-dark mb-1">Date</label>
                  <p className="mb-0 font-14 font-semibold">
                    {receiptInfo?.date ?? "-"}
                  </p>
                </Col>
              </Row>
            </Card.Body>
          </Card>
          <Card className="card-style mb-lg-4 mb-3">
            <Card.Header>
              <h4 className="card-title">Received From</h4>
            </Card.Header>
            <Card.Body>
              <Row className="w-100">
                <Col lg={3} xs={6} className="mb-3 ">
                  <label className="text-secondary-dark mb-1">Name</label>
                  <p className="mb-0 font-14 font-semibold">
                    {receiptInfo?.received_From ?? "-"}
                  </p>
                </Col>
                <Col lg={3} xs={6} className="mb-3">
                  <label className="text-secondary-dark mb-1">
                    Property Name
                  </label>
                  <p className="mb-0 font-14 font-semibold">
                    {receiptInfo?.property_name ?? "-"}
                  </p>
                </Col>
                {receiptInfo?.building_name !== "" ? (
                  <Col lg={3} xs={6} className="mb-3">
                    <label className="text-secondary-dark mb-1">Building</label>
                    <p className="mb-0 font-14 font-semibold">
                      {receiptInfo?.building_name ?? "-"}
                    </p>
                  </Col>
                ) : (
                  ""
                )}

                {receiptInfo?.property_type === "MULTIPLE_UNIT" ? (
                  <Col lg={3} xs={6} className="mb-3">
                    <label className="text-secondary-dark mb-1">Unit</label>
                    <p className="mb-0 font-14 font-semibold">
                      {receiptInfo?.unit}
                    </p>
                  </Col>
                ) : (
                  ""
                )}
                {receiptInfo?.room !== "" ? (
                  <Col lg={3} xs={6} className="mb-3">
                    <label className="text-secondary-dark mb-1">Room</label>
                    <p className="mb-0 font-14 font-semibold">
                      {receiptInfo?.room}
                    </p>
                  </Col>
                ) : (
                  ""
                )}
                {receiptInfo?.bed !== "" ? (
                  <Col lg={3} xs={6} className="mb-3">
                    <label className="text-secondary-dark mb-1">Bed</label>
                    <p className="mb-0 font-14 font-semibold">
                      {receiptInfo?.bed}
                    </p>
                  </Col>
                ) : (
                  ""
                )}
              </Row>
            </Card.Body>
          </Card>
          <Card className="card-style mb-lg-4 mb-3">
            <Card.Header>
              <h4 className="card-title">Received To</h4>
            </Card.Header>
            <Card.Body>
              <Row className="w-100">
                <Col lg={3} xs={12} className="mb-3 ">
                  <label className="text-secondary-dark mb-1">
                    Company/Individual Name
                  </label>
                  <p className="mb-0 font-14 font-semibold">
                    {receiptInfo?.received_to}
                  </p>
                </Col>
                <Col lg={3} xs={12} className="mb-3">
                  <label className="text-secondary-dark mb-1">Property</label>
                  <p className="mb-0 font-14 font-semibold">
                    {receiptInfo?.property_name}
                  </p>
                </Col>
              </Row>
            </Card.Body>
          </Card>
          <Card className="card-style mb-lg-4 mb-3">
            <Card.Header>
              <h4 className="card-title">Received Amount</h4>
            </Card.Header>
            <Card.Body>
              {receiptInfo &&
                receiptInfo?.receipt_details?.length > 0 &&
                receiptInfo?.receipt_details?.map(
                  (receipt: any, index: any) => {
                    return (
                      <Row className="w-100" key={`receipt_${index}`}>
                        <Col lg={3} xs={6} className="mb-3 ">
                          <label className="text-secondary-dark mb-1">
                            Category
                          </label>
                          <p className="mb-0 font-14 font-semibold">
                            {receipt?.category?.title ?? "-"}
                          </p>
                        </Col>
                        <Col lg={3} xs={6} className="mb-3">
                          <label className="text-secondary-dark mb-1">
                            Amount
                          </label>
                          <p className="mb-0 font-14 font-semibold">
                            ₹ {receipt?.amount}
                          </p>
                        </Col>
                        <Col lg={3} xs={6} className="mb-3">
                          <label className="text-secondary-dark mb-1">
                            Mode
                          </label>
                          <p className="mb-0 font-14 font-semibold">
                            {HelperService.removeUnderScore(
                              receipt?.payment_method ?? "-"
                            )}
                          </p>
                        </Col>
                        <Col lg={3} xs={6} className="mb-3">
                          <label className="text-secondary-dark mb-1">
                            Transaction Number
                          </label>
                          <p className="mb-0 font-14 font-semibold">
                            {receipt?.transaction_number ?? "-"}
                          </p>
                        </Col>
                      </Row>
                    );
                  }
                )}
              <Col lg={12}>
                {" "}
                <hr className=" border-secondary" />{" "}
              </Col>

              <Row>
                <Col lg={3} xs={4} className=" d-lg-block d-none"></Col>
                <Col lg={3} xs={12} className="  text-lg-start text-end">
                  <label className="text-secondary-dark mb-1">
                    Total Amount
                  </label>
                  <p className="mb-0 font-14 font-semibold">
                    ₹ {receiptInfo?.total_amount}
                  </p>
                </Col>
                <Col lg={3} xs={4} className=" d-lg-block d-none"></Col>
                <Col lg={3} xs={4} className=" d-lg-block d-none"></Col>
              </Row>
            </Card.Body>
          </Card>
        </div>
      )}

      <DeleteModal
        action={action}
        closeModal={(flag: any) => {
          handleCloseModal(flag);
        }}
        show={show}
      />
    </>
  );
};
export default ReceiptDetail;
